import { useSearch } from '../../../../hooks/context';
import useMapConfig from '../../../../components/map/hooks/use-map-config';
import useFilterSearch from '../../../../hooks/use-filter-search';
import { trackClickEvent } from '../../../../components/map/track';
import { LAYOUTS } from '../../../../constants';
import { useSearchClient } from '../../../../hooks/use-search-client';

export const useHighlightsFilters = ({ setIsChecked, url, filterId }) => {
  const { searchTrack } = useMapConfig();
  const { layout_options } = useSearch();
  const filterSearch = useFilterSearch(url, filterId);
  const isClientSideFilter = Boolean(filterSearch);
  const { handleLinkSPA } = useSearchClient();

  const onClickHighlighted = () => {
    setIsChecked((prev) => !prev);

    if (isClientSideFilter) {
      filterSearch();

      if (layout_options?.current === LAYOUTS.TYPE_MAP) {
        trackClickEvent(null, { melidata_track: { ...searchTrack, type: 'view' } });
      }

      return;
    }

    handleLinkSPA({ href: url });
  };

  return { onClickHighlighted };
};
